import {Module} from "../common/Module";
import {AuthenticatedUser} from "../users/AuthenticatedUser";
import {Nullable} from "../common/Nullable";
import {isPrivileged} from "../../config/Privileges";
import {ReportingAreaType} from "./ReportingAreaType";

export const ProjectReportModule: Module = {
    identifier: "project_report",
    isPrivileged(authUser: Nullable<AuthenticatedUser>, privilege: string, privilegeIdentifier: string | undefined): boolean {
        return isPrivileged(authUser, ReportingAreaType, ProjectReportModule.identifier, privilege );
    }
};